import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import LogsSection from "../sections/LogsSection";

export function LogsPage({ logs }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Логи"
        description="Ищите логи по id, смотрите активность пользователей и последние диалоги с GPT."
      />
      <PageContent>
        <LogsSection mode="page" state={logs.state} actions={logs.actions} />
      </PageContent>
    </div>
  );
}

export default LogsPage;
